<template>
    <div class="dashboard">
        <template>
            <el-card style='padding:0px 5px 0px 5px' v-loading="rowLoading">
                <div style='width:49%;padding-right:1%;float:left;border-right:1px dashed #ccc;'>
                    <h4 class='mb15'><i class='el-icon-lx-calendar icon2 size20'></i>{{query.dayType==1?"":query.dayType==2?"近30天":query.dayType==3?"近7天":query.dayType==4?"今日":"-"}}产品订购排行（共{{query.num}}条）</h4>
                    <el-card class="progress-card" v-for="item in goodsData" >
                        <div class="progress-header">
                            <div class="progress-title">
                                <i class="el-icon-timer"></i>
                                <span>{{ item.goodsName }} <i class="el-icon-lx-attention ml10"></i> <a @click='handleCellClick(item)' style='color:var(--theme_bgcolor)'> 通过率</a></span>
                            </div>
                        </div>
                        <el-progress
                            class="custom-progress"
                            :format="(percentage) => formatProgress(percentage, item)"
                            :stroke-width="10"
                            :percentage="item.goodsRate"
                            color="#f8893b"
                        ></el-progress>
                    </el-card>
                </div>
                <div style='width:49%;float:right;' >
                    <h4 class='mb15'><i class='el-icon-lx-calendar icon2 size20'></i>{{query.dayType==1?"":query.dayType==2?"近30天":query.dayType==3?"近7天":query.dayType==4?"今日":"-"}}产品转化排行（共{{query.num}}条）</h4>
                    <span class='label6' style='float:right;margin-top:-35px;margin-right:10px;'><i class='el-icon-lx-filter pointer' @click="selectGoods('1')"></i></span>
                    <el-card class="progress-card" v-for="item in goodsData2" >
                        <div class="progress-header">
                            <div class="progress-title">
                                <i class="el-icon-timer"></i>
                                <span>{{ item.goodsName }}</span>
                            </div>
                        </div>
                        <el-progress
                            class="custom-progress"
                            :format="(percentage) => formatProgress2(percentage, item)"
                            :stroke-width="10"
                            :percentage="item.goodsRate"
                            color="#f8893b"
                        ></el-progress>
                    </el-card>
                </div>
                <div style='clear:both'></div>
            </el-card>
        </template>
        <el-drawer title="条件筛选" :visible.sync="editVisible" direction="rtl" :append-to-body='true' width="500px" height="60%">
            <el-form ref="form1" :model="form1" label-width="120px">
                <span class="label-span ml10">
                    <label class="label">查询日期</label>
                    <el-radio-group v-model.trim="form1.dayType" >
                        <el-radio-button label="1">全部时间</el-radio-button>
                        <el-radio-button label="2">近 30天</el-radio-button>
                        <el-radio-button label="3">近 7 天</el-radio-button>
                        <el-radio-button label="4">今日</el-radio-button>
                    </el-radio-group>
                </span>
                <span class="label-span ml10">
                    <label class="label">查询条数</label>
                   <el-radio-group v-model.trim="form1.num" >
                        <el-radio-button label="5"> 5 条</el-radio-button>
                        <el-radio-button label="10">10条</el-radio-button>
                        <el-radio-button label="15">15条</el-radio-button>
                    </el-radio-group>
                </span>
            </el-form>
            <el-button style='margin-left:10px;margin-top:10px;width: 100px;font-size: 15px;height: 35px;' type="primary" @click="setDataParam">{{ isSubmitting ? '查询中...' : '确 认' }}</el-button>
        </el-drawer>
        <el-drawer :title="goodsName+' - 进单环节分析'" :visible.sync="intoVisible"
                   direction="rtl" :append-to-body='true' height="60%">
            <div style="margin:0 30px">
                <el-table :data="tableData2" border row-key="superiorId" v-loading="loadingDrawer"
                          :highlight-current-row="true">
                    <el-table-column prop="crossName" width="150" align="center" label="进单环节">
                        <template slot-scope="scope">
                            <b>{{ scope.row.crossName }}</b>
                        </template>
                    </el-table-column>
                    <el-table-column prop="crossNum" width="120" align="center" label="单量"></el-table-column>
                    <el-table-column prop="crossPre" width="120" align="center" label="占比">
                        <template slot-scope="scope">
                            <div v-if="scope.row.crossName !== '汇总'">
                                <b>{{ scope.row.crossPre }}%</b>
                            </div>
                        </template>
                    </el-table-column>

                </el-table>
            </div>

        </el-drawer>
    </div>
</template>

<script>
import {
    getGoodsShowNum
} from '../../../api/orderStatistics/tsShow';
import { fetchSelect3 as fetchSelect } from '../../../api/comGoods';
import * as echarts from 'echarts';
import numeral from 'numeral';
import { fetchSelect as fetchSelect1 } from '@/api/channelType';
import { conversionAnalysisByProductAndMember, dataStatistics30 } from '@/api/orderStatistics/orderStatustucs';


export default {
    name: 'charts',
    data() {
        return {
            rowLoading: false,
            schartLoading: false,
            schartLoading1: false,
            channelLoading: false,
            productLoading: false,
            memloading2: false,
            isSubmitting:false,
            memloading1: false,
            editVisible:false,
            lastTotalAvg: 0,
            refreshProgress: 100, // 初始进度为100%
            refreshCountdown: 10, // 初始倒计时为10秒
            refreshInterval: null,// 存储定时器ID
            chartHeight :160,
            form1:{dayType:'1',num:'5'},
            select:{option:''},
            tableData2:false,
            tsData:{
                successNum:'',
                tsNum:'',
                tsPre:'',
            },
            query:{dayType:'1',num:'5'},
            tsData2:{
                successNum:'',
                tsNum:'',
                tsPre:'',
            },
            goodsData:[],
            goodsData2:[],
            goodsFag:'1',
            intoVisible:false,
            goodsName:'',
        };
    },

    beforeDestroy() {
    },
    created() {  },
    mounted() {
        this.initData();

    },
    computed: {  },
    methods: {
        handleCellClick(item) {
            this.intoVisible = true;
            this.goodsName = item.goodsName;
            this.queryByProduct.goodsCode = item.goodsCode;
            this.loadingDrawer = true;
            conversionAnalysisByProductAndMember(this.queryByProduct).then(res => {
                if (res.code == 200) {
                    this.tableData2 = res.data.tableData;
                }
                this.loadingDrawer = false;
            });


        },
        formatProgress(percentage, item) {
            return ` 订购量:${item.goodsSuccess} | 转化率:${item.goodsRate}% | 请求量:${item.goodsRequest} | 上架时间:${item.upTime}`;
        },
        formatProgress2(percentage, item) {
            return ` 转化率:${item.goodsRate}% | 订购量:${item.goodsSuccess} | 请求量:${item.goodsRequest} | 上架时间:${item.upTime}`;
        },
        getOrderStatistics30(){
            let query = {};
            dataStatistics30(query).then(res => {
                if (res.code == '200') {
                    if (type.startsWith("channel")) {

                        let option1Sum = res.data.channelOrderData.longs.reduce((total, current) => total + current, 0);
                        if (!option1Sum) {
                            option1Sum = 0;
                        }
                        this.option1.title.text = '近30天渠道销售图 总计(' + option1Sum + ') ';
                        this.option1.labels = res.data.channelOrderData.cnames;
                        this.option1.datasets[0].data = res.data.channelOrderData.longs;
                    } else {
                        this.option4 = res.data.products;
                        if (res.data.products) {
                            this.lastTotalAvg = res.data.products.reduce((sum, item) => sum + item.success, 0);
                        } else {
                            this.lastTotalAvg = 0;
                        }
                    }

                    this.channelLoading = false;
                    this.productLoading = false;
                    console.log('dataStatistics30接口返回=====>', res);
                }
            });
        },

        // 编辑操作
        selectGoods(i) {
            this.goodsFag = i;
            this.editVisible = true;
        },
        formatCurrency(value) {
            return numeral(value).format('$0,0.00');
        },
        formatPercentage(value) {
            return numeral(value).format('0.00%');
        },
        setDataParam(){
            this.query = this.form1;
            this.initData();
            this.editVisible = false;
        },
        initData(){
            this.rowLoading = true;
            getGoodsShowNum(this.query).then(res => {
                this.rowLoading = false;
                if(res.code=='200'){
                    this.goodsData = res.data.goodsData;
                    this.goodsData2 = res.data.goodsData2;
                }else{
                    this.$message.error(res.message);
                }
            });
        },
        getChartData() {
            this.rowLoading = true;
            this.schartLoading = true;
            let data = {};
            getChartDataByGoods(data).then(res => {
                if (res.code == '200'){
                    this.initChart('echart1', '产品投诉', res.data.chartX1, res.data.chartY1_1,res.data.chartY1_2,res.data.chartY1_3);
                    this.initChart('echart2', '本月新增', res.data.chartX2, res.data.chartY2_1,res.data.chartY2_2,res.data.chartY2_3);
                }
                this.schartLoading = false;
            })
            this.getChartDataByMem1();
            this.getChartDataByMem2();
        },
        getChartDataByMem1(){
            let data = {};
            data.goodsCode = this.form1.goodsCode1;
            this.memloading1 = true;
            this.editVisible = false;
            getChartDataByMem1(data).then(res => {
                if (res.code == '200'){
                    this.initChart('echart3', '渠道投诉', res.data.chartX1, res.data.chartY1_1,res.data.chartY1_2,res.data.chartY1_3);
                    this.memloading1 = false;
                }
            })
        },
        getChartDataByMem2(){
            let data = {};
            data.goodsCode = this.form1.goodsCode2;
            this.memloading2 = true;
            this.editVisible = false;
            getChartDataByMem2(data).then(res => {
                if (res.code == '200'){
                    this.initChart('echart4', '本月新增', res.data.chartX1, res.data.chartY1_1,res.data.chartY1_2,res.data.chartY1_3);
                    this.memloading2 = false;
                }
            })
        },
        getSelect(){
            this.select = {};
            this.select.channelCode = '46';
            fetchSelect(this.select).then(res => {
                if(res.code=='200'){
                    this.$set(this.select, 'option', res.data);
                }
            });
        },
        initChart(id, title, categories, data1, data2, data3) {
            const chart = echarts.init(document.getElementById(id));
            const option = {
                title: {
                    text: title ,
                    textStyle: {
                        color: 'rgba(30,30,30,0.84)',
                        fontSize: 13
                    },
                    right: 'right',
                    top: 'top',
                    fontStyle: 'italic',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '5%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: categories,
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLabel: {
                        rotate: 30, // 旋转角度
                        interval: 0, // 强制显示所有标签
                        fontSize: 10,
                        formatter: function(value) {
                            // 或者超出长度显示省略号
                            return value.length > 12 ? value.substring(0,10)+'...' : value;
                        }
                    }
                },
                yAxis: {
                    type: 'value',

                },
                series: [{
                    name: '订购量',
                    type: 'bar',
                    color: 'rgb(239, 82, 105)',
                    data: data1
                },{
                    name: '投诉量',
                    type: 'bar',
                    color: 'rgb(250,185,20)',
                    data: data2
                },{
                    name: '投诉率',
                    type: 'bar',
                    color: 'rgb(250,124,20)',
                    data: data3
                }]
            };
            chart.setOption(option);
        }
        ,initChart3(id, title, categories, data) {
            const chart = echarts.init(document.getElementById(id));
            const option = {
                title: {
                    text: title ,
                    textStyle: {
                        color: 'rgba(128,142,230,0.84)',
                        fontSize: 14
                    },
                    right: 'right',
                    top: 'top',
                    fontStyle: 'italic',
                },
                tooltip: {
                    alwaysShowContent: true,
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: function(params) {
                        // 打印 params 以查看其结构
                        console.log(params);
                        // 获取 X 轴的值
                        const xAxisValue = params[0].axisValue;

                        // 构建提示框内容
                        return `${xAxisValue}<br/>` + params.map(item => {
                            return `${item.seriesName}:  ${item.value}%`;
                        }).join('<br/>');
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '10%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: categories,
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLabel: {
                        rotate: 30, // 旋转角度
                        interval: 0, // 强制显示所有标签
                        fontSize: 10,
                        formatter: function(value) {

                            // 或者超出长度显示省略号
                            return value.length > 5 ? value.substring(0,5)+'...' : value;
                        }
                    }
                },
                yAxis: {
                    type: 'value',

                },
                series: [{
                    name: title,
                    type: 'bar',
                    color: 'rgb(239, 82, 105)',
                    data: data
                }]
            };
            chart.setOption(option);
        }
        ,
        initChart1(id, title, categories, data,dataTitle,data2,data2Title) {
            const chart = echarts.init(document.getElementById(id));
            const option = {
                title: {
                    text: title,
                    textStyle: {
                        color: 'rgba(128,142,230,0.84)',
                        fontSize: 14
                    },
                    right: 'right',
                    top: 'top',
                    fontStyle: 'italic',},
                tooltip: {
                    show: true,
                    trigger: 'axis'
                },
                legend: {
                    data: [dataTitle,data2Title]
                },
                xAxis: {
                    data: categories,
                    axisLabel: {
                        rotate: 30, // 旋转角度
                        interval: 0 // 强制显示所有标签
                    }
                },
                yAxis: {},
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '10%',
                    containLabel: true
                },
                series: [{
                    name: dataTitle,
                    type: 'line',
                    data: data,
                    color: '#e30627'
                },{
                    name: data2Title,
                    type: 'line',
                    data: data2,
                    color: '#089107'
                }
                ]
            };
            chart.setOption(option);
        }
        ,


        getIconClass(title) {
            const iconMap = {
                '今日订购量': 'el-icon-s-claim',
                '今日请求量': 'el-icon-lx-warnfill',
                '本周订购量': 'el-icon-lx-warnfill',
            };
            return iconMap[title] || '';
        },
    }
};

</script>


<style>
.dashboard {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    padding: 5px;
}
.chart-rows {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

.card-container {
    width: 96%;
    margin: 0px 2%;
    position: relative;
    overflow: visible;
}

.top-card {
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 5px 0;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.8);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
    z-index: 2;
    position: relative;
}

.card-title {
    font-size: 12px;
    margin-top: 0; /* 移除顶部间距 */
    text-align: center;
    color:#666;
}
.card-title2 {
    font-size: 13px;
    margin-top: 0; /* 移除顶部间距 */
    text-align: center;
    color: #666;
}

.card-value {
    font-size: 15px;
    font-weight: bold;
    margin-top: 5px;
    text-align: center;
    color: #666;
}
.card-value2 {
    font-size: 25px;
    font-weight: bold;
    margin-top: 5px;
    text-align: center;
    color: rgba(2, 174, 7, 0.8);
}

.el-col-4 {
    width: 16.6%;
}

.hover-layer {
    border-radius: 10px;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, #7ebcfd, #7ebcfd);
    transform: scale(0);
    transform-origin: center center;
    opacity: 0.6;
    transition: all 0.4s ease-in-out;
    z-index: 1;
    pointer-events: none;
}

.card-container:hover .hover-layer {
    transform: scale(1);
    opacity: 1;
}
.card-value span {
    font-weight: normal;
}

.card-value .positive {
    color: #2ecc71; /* 鲜亮绿色，表示增长 */
}

.card-value .negative {
    color: #f8893b; /* 鲜艳红色，表示下降 */
}
.echartswh {
    padding:10px 2%;
    width: 96%;
    height: 100%; /* 自动继承父容器高度 */
    min-height: 180px; /* 最小高度兜底 */

}
.echartswh1{
    padding:10px 2%;
    width: 96%;
    height: 100%; /* 自动继承父容器高度 */
    min-height: 210px; /* 最小高度兜底 */
}
.echartswh2{
    width: 100%;
    height: 100%;
    min-height: 180px; /* 最小高度兜底 */
}

.icon {
    font-size: 45px;
    height: 100px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    vertical-align: middle;
    color: #f8893b;
}
.icon2 {
    color: #f8893b;
    font-weight: 700;
    margin-right:5px;
}
.card-content {
    display: flex;
    align-items: center;
    padding: 10px;
}
.text-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center; /* 确保文本居中对齐 */
}
@media (max-width: 768px) {
    .el-col-4 {
        width: 50%; /* 手机端两列显示 */
        margin-bottom: 10px;
    }
}
@media (min-width: 769px) and (max-width: 1024px) {
    .el-col-4 {
        width: 33.33%; /* 平板三列显示 */
    }
}

.el-row {
    margin-bottom: 2px !important;
}
.mt5{
    margin-top:5px !important;
}
/*
.card-content{
       内联元素（inline）动画不起作用， 因此要设置为‘inline-block’
       animation: jump2 2s infinite ease-in-out;
       animation-delay: var(--delay);
     }

     @keyframes jump2 {
       100% {
         transform: translateY(0);
       }
       50% {
         transform: translateY(-10px);
       }
     } */

.iconJump2 {
    color: #409EFF;
    background-image: -webkit-linear-gradient(90deg, #409EFF, #01ac25);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-animation: change2 5s infinite linear;
}
@-webkit-keyframes change2 {
    from {
        -webkit-filter: hue-rotate(0deg);
    }
    to {
        -webkit-filter: hue-rotate(-360deg);
    }
}

.progress-card {
    background-color: #f9f9f9;
    padding: 5px 10px 0 10px;
    border-radius: 8px;
    margin-bottom: 15px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.03);
    transition: all 0.3s ease;
}

.progress-card:hover {
    background-color: #f1f1f1;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.06);
}

.progress-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
}

.progress-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #333;
    font-weight: bold;
}

.progress-title i {
    color: #409EFF;
}
.progress-date {
    display: inline-block;
    width: 600px; /* 固定宽度便于对齐 */
    font-size: 14px;
    color: #666;
    margin-right: 16px;
}

.custom-progress {
    display: inline-block;
    width: 100%; /* 配合日期宽度 */
    vertical-align: middle;
    margin-bottom: 12px;
}

.el-progress__text {
    font-size: 12px !important;
    color: #555;
    margin-left: 20px;
    margin-top:5px;
}
.progress-item {
    margin-bottom: 16px;
    padding: 8px 12px;
    background-color: #f9f9f9;
    border-radius: 6px;
    transition: background-color 0.3s ease;
}

.progress-item:hover {
    background-color: #f1f1f1;
}

.progress-value {
    font-size: 13px;
    color: #666;
}

.custom-progress .el-progress-bar__outer {
    background-color: #e8f5e9;
    border-radius: 4px;
    height: 10px !important;
}

.custom-progress .el-progress-bar__inner {
    border-radius: 4px;
    transition: width 0.5s ease-in-out;
}
</style>
